<template>
	<div>
		<div class="pt-0 pl-3 pr-0 ml-0 ml-0 practice-view-card">
			<v-row no-gutters class="pb-3">
				<v-col>
					<v-card class="elevation-1 justify-center text-center" color="white">
						<v-row v-if="showPracticeSection && practiceData">
							<v-col :cols="6" :lg="6">
								<v-row>
									<v-col>
										<div>
											<v-btn class="v-btn v-btn--text theme--light v-size--default secondary--text" style="float: left" text @click="cancelPracticeView()"
												><v-icon left large color="secondary">mdi-chevron-left</v-icon>Back</v-btn
											>
										</div>
									</v-col>
								</v-row>

								<div>
									<v-list-item-avatar size="140" align="center" justify="center">
										<v-skeleton-loader v-if="!practiceImage" type="image" :loading="true" :width="140" :height="140" align="center" justify="center">
										</v-skeleton-loader>
										<v-img v-if="practiceImage" :src="practiceImage"></v-img>
									</v-list-item-avatar>
								</div>

								<div class="title black--text font-weight-black mt-2">{{ practice.name }}</div>

								<div v-if="practice.address" class="pl-3" align="left">
									<div class="black-text font-weight-black mt-4 mb-2">{{ getLabel('companyAddress', 'Practice Address') }}</div>

									<div v-for="addressLine in practiceAddressLines" :key="addressLine">
										<small>
											{{ addressLine }}
										</small>
									</div>
								</div>
							</v-col>
							<v-col :cols="6" :lg="6" class="text-left">
								<div v-for="detail in practiceDetails" :key="detail.value">
									<div v-if="detail.value" class="mt-1" style="display: flex">
										<strong class="mr-1 mt-1">
											<small>{{ detail.name }}:</small>
										</strong>
										<div class="mt-1">
											<small>
												{{ detail.value }}
											</small>
										</div>
									</div>
								</div>

								<div v-if="practiceManager" class="mt-3">
									<div>
										<strong>
											<small>Manager Details:</small>
										</strong>
									</div>

									<div class="mt-1">
										<div class="mt-1">
											<small>
												{{ practiceManager }}
											</small>
										</div>
									</div>
								</div>

								<div class="mt-5">
									<v-row align="center" justify="center">
										<v-col cols="12" sm="12" md="12">
											<v-btn
												v-if="viewSource.includes('calendarDashboardSearch')"
												class="white--text button-rounded mt-2"
												:height="25"
												width="80%"
												color="#63C367"
												@click="sendBookingRequest()"
												><span style="font-size: 10px">{{ getLabel('bookingFlowSendBookingRequest', 'Send Booking Request') }}</span></v-btn
											>
										</v-col>
									</v-row>
								</div>
							</v-col>
						</v-row>

						<hr v-if="showPracticeSection && practiceFromStore.booking" style="background: #f0f0f0; width: 85%; margin: auto; border: none; height: 2px" class="mt-4" />

						<v-row v-if="!showPracticeSection">
							<v-col>
								<div>
									<v-btn class="v-btn v-btn--text theme--light v-size--default secondary--text" style="float: left" text @click="cancelPracticeView()"
										><v-icon left large color="secondary">mdi-chevron-left</v-icon>Back</v-btn
									>
								</div>
							</v-col>
						</v-row>

						<div v-if="practiceFromStore.booking" class="mt-4 pl-2">
							<div class="black-text font-weight-black" align="left">{{ bookingType }} Details:</div>
							<booking-details :booking="booking" :show-date-selection="viewSource === 'viewOffersNearMe' || viewSource === 'viewBookingRequest'" />
						</div>

						<div v-if="practiceFromStore.id">
							<booking-cost-summary :dates="costSummaryDates" :locum="locum" :booking="booking"></booking-cost-summary>
						</div>

						<v-row class="pb-3">
							<v-spacer />
							<v-col :cols="6" align="left" justify="left">
								<div v-if="viewSource === 'viewBookingRequest'">
									<v-btn style="position: relative" class="white--text button-rounded mt-2" :height="25" width="80%" color="accent" @click="openMessageDialog()"
										><span style="font-size: 10px">Message</span>
										<v-badge
											class="badge-styling"
											:content="unreadMessageCount"
											:value="unreadMessageCount"
											color="primary"
											overlap
											bottom
											bordered
											offset-y="bottom"
											offset-x="right"
										></v-badge>
									</v-btn>

									<v-btn
										class="white--text button-rounded mt-2"
										:height="25"
										width="80%"
										color="#63C367"
										@click="isPrivate ? doLocumAcceptPrivateRequest() : doLocumConfirmBookingRequest()"
										><span style="font-size: 10px">Accept</span></v-btn
									>
									<v-btn
										class="white--text button-rounded mt-2"
										:height="25"
										width="80%"
										color="primary"
										@click="isPrivate ? doLocumRejectPrivateRequest() : doLocumRejectBookingRequest()"
										><span style="font-size: 10px">Decline</span></v-btn
									>
								</div>
								<div v-if="viewSource === 'viewOffersNearMe'">
									<v-btn
										:loading="loading"
										:disabled="noDatesSelected"
										class="white--text button-rounded"
										:height="25"
										width="80%"
										color="#63C367"
										@click="doLocumConfirmOffer"
										><span style="font-size: 10px">Send Application</span></v-btn
									>
								</div>
								<div v-if="['viewUpcomingBooking', 'viewApplicationSent'].includes(viewSource)" class="pr-2">
									<div v-if="!showCancel">
										<v-btn
											v-if="viewSource !== 'viewApplicationSent'"
											style="position: relative"
											class="white--text button-rounded mt-2"
											:height="25"
											width="100%"
											color="accent"
											@click="openMessageDialog()"
											><span style="font-size: 10px">Message</span>
											<v-badge
												class="badge-styling"
												:content="unreadMessageCount"
												:value="unreadMessageCount"
												color="primary"
												overlap
												bottom
												bordered
												offset-y="bottom"
												offset-x="right"
											></v-badge>
										</v-btn>
										<v-btn
											v-if="viewSource !== 'viewApplicationSent'"
											class="white--text button-rounded mt-2"
											:height="25"
											width="100%"
											color="#f44336"
											@click="showCancel = true"
											><span style="font-size: 10px">Cancel Booking {{ viewSource === 'viewBookingRequestSent' ? 'Request' : '' }}</span></v-btn
										>

										<v-btn
											v-if="viewSource === 'viewApplicationSent'"
											style="position: relative"
											class="white--text button-rounded mt-2"
											:height="25"
											width="100%"
											color="accent"
											@click="openMessageDialog()"
											><span style="font-size: 10px">Message</span>
											<v-badge
												class="badge-styling"
												:content="unreadMessageCount"
												:value="unreadMessageCount"
												color="primary"
												overlap
												bottom
												bordered
												offset-y="bottom"
												offset-x="right"
											></v-badge
										></v-btn>

										<v-btn
											v-if="viewSource === 'viewApplicationSent'"
											class="white--text button-rounded mt-2"
											:height="25"
											width="100%"
											color="secondary"
											@click="editApplicationToOffer()"
											><span style="font-size: 10px">Edit Application</span></v-btn
										>
										<v-btn
											v-if="viewSource === 'viewApplicationSent'"
											class="white--text button-rounded mt-2"
											:height="25"
											width="100%"
											color="primary"
											@click="showCancel = true"
											><span style="font-size: 10px">Cancel Application</span></v-btn
										>
									</div>
									<div v-if="showCancel">
										<div>
											<p>
												<b>Cancellation Reason</b>
											</p>
											<v-textarea v-model="cancellationReason" style="font-size: 11px" auto-grow filled color="primary" rows="1"></v-textarea>
										</div>
										<v-btn
											class="white--text button-rounded"
											:height="25"
											color="primary"
											width="100%"
											:disabled="cancellationReason.length < 5"
											@click="cancelBooking"
											><span style="font-size: 10px">Submit Cancellation</span></v-btn
										>
										<v-btn class="white--text button-rounded mt-2" :height="25" color="#4d88a1 " width="100%" @click="showCancel = false"
											><span style="font-size: 10px">Nevermind</span></v-btn
										>
									</div>
								</div>
								<div v-if="viewSource === 'viewApplicationSent'"></div>
								<div v-if="viewSource === 'viewPostedOffer'">
									<v-btn class="white--text button-rounded mt-2" :height="25" width="80%" color="#f44336" @click="deletePublicOffer()"
										><span style="font-size: 10px">Cancel this offer</span></v-btn
									>
								</div>
								<div v-if="viewSource === 'viewLocumAvailability'">
									<v-btn class="white--text button-rounded mt-2" :height="25" width="80%" color="secondary" @click="editAvailability()"
										><span style="font-size: 10px">Edit {{ bookingType }}</span></v-btn
									>
								</div>
								<div v-if="viewSource === 'viewLocumAvailability'">
									<v-btn class="white--text button-rounded mt-2" :height="25" width="80%" color="#f44336" @click="startDelete()"
										><span style="font-size: 10px">Delete {{ bookingType }}</span></v-btn
									>
								</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
		</div>
		<LocumEditAvailabilityDialog ref="locumEditBooking" :booking="booking"></LocumEditAvailabilityDialog>
		<LocumEditApplicationDialog ref="locumEditApplication" :application="booking" @applicationUpdate="updateApplicationDetails"></LocumEditApplicationDialog>
	</div>
</template>

<script>
import store from '@/store';
import { bus } from '@/main';
import axios from 'axios';
import moment from 'moment';

import BookingDetails from '@/components/custom/BookingDetails.vue';
import { mapMutations, mapGetters, mapActions } from 'vuex';
import BookingCostSummary from '@/components/custom/BookingCostSummary.vue';
import LocumEditAvailabilityDialog from '@/components/ui/dashboard/locum/LocumEditAvailabilityDialog.vue';
import LocumEditApplicationDialog from '@/components/ui/dashboard/locum/LocumEditApplicationDialog.vue';

export default {
	name: 'ViewPracticeDetailsCard',
	components: { BookingDetails, BookingCostSummary, LocumEditAvailabilityDialog, LocumEditApplicationDialog },
	data: () => ({
		calendarInputMode: 0,
		range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
		selectedDatesSorted: [],
		person_outline_img: require('@/assets/images/rocket_man_transparent.webp'),
		practiceImage: '',
		practiceData: null,
		showCancel: false,
		selectedDates: [],
		noDatesSelected: true,
		cancellationReason: '',
		API_URL: store.getters.getAPI,
		loading: false,
		costSummaryDates: [],
		orinalOfferDatesTimes: [],
		unreadMessageCount: 0,
	}),
	computed: {
		...mapGetters(['user']),

		locum() {
			return this.user;
		},

		computedMatchMin() {
			return Math.max(50, this.PercentageMatch());
		},
		showPracticeSection() {
			return this.viewSource !== 'viewLocumAvailability';
		},
		locumExperience() {
			if (!this.practice.experience) {
				return 0;
			}
			const experienceYears = moment().diff(moment(this.practice.experience.start_date), 'years');
			const experienceSuffix = experienceYears === 1 ? ' year' : ' years';
			return experienceYears + experienceSuffix;
		},
		practiceManager() {
			const { managers = [] } = this.practice;
			if (!managers[0]) {
				return '';
			}
			return `${managers[0].name} ${managers[0].surname}`;
		},
		practiceAddressLines() {
			const { building_name, street, suburb, region, province } = this.practice.address;
			return [`${building_name ?? ''} ${street}`, `${suburb} ${region}`, `${province}`];
		},
		practiceDetails() {
			const { short_bio, systemsUsed, languages, professionalInsuranceCover } = this.practice;
			return [
				{
					name: 'Description',
					value: short_bio,
				},
				{
					name: 'Systems Used',
					value: systemsUsed,
				},
				{
					name: 'Malpractice Insurance',
					value: professionalInsuranceCover ? 'Yes' : 'No',
				},
				{
					name: 'Languages',
					value: languages ? languages.join(', ') : null,
				},
			];
		},
		practice() {
			return this.practiceData;
		},
		practiceFromStore() {
			return store.getters.getLocumViewingPractice;
		},
		booking() {
			return this.practiceFromStore.booking;
		},
		viewSource() {
			return this.practiceFromStore.source;
		},
		authToken() {
			return store.getters.jwtToken;
		},
		isPrivate() {
			return 'offer' in store.getters.getLocumPracticeRequestSelected;
		},
		bookingType() {
			if (this.practiceFromStore.id) {
				return 'Booking';
			} else {
				return this.booking && this.booking.status === 'unavailable' ? 'Unavailability' : 'Availability';
			}
		},
	},
	async mounted() {
		if (this.practiceFromStore.id) {
			this.fetchPracticeData();
			bus.$on('update-component', () => {
				this.practiceImage = null;
				this.practiceData = null;
				this.fetchPracticeData();
			});
		}
		if (this.viewSource === 'viewOffersNearMe' || this.viewSource === 'viewBookingRequest') {
			bus.$on('update-selected-dates', newDates => {
				this.selectedDates = newDates;
				this.noDatesSelected = !Object.values(this.selectedDates).some(value => value);
			});
		}

		if (this.booking) {
			const { start_time, end_time, booking_dates } = this.booking;
			if (booking_dates && start_time && end_time) {
				let dates = [];
				if (this.booking.request_dates) {
					dates.push(...this.booking.request_dates.map(requestDate => ({ date: requestDate.date, start_time: requestDate.start_time, end_time: requestDate.end_time })));
				} else {
					dates = booking_dates.map(bookingDate => ({ date: bookingDate, start_time, end_time }));
				}
				this.costSummaryDates = dates;
			}
		}
		await this.getUnreadMessageCount();
	},
	beforeDestroy() {},
	methods: {
		...mapMutations('offers', ['UPDATE_OFFERS']),

		...mapActions('offers', ['UpsertOffer']),

		...mapMutations('bookings', ['UPDATE_COMPANY_BOOKINGS']),

		...mapMutations('availability', ['REMOVE_PROFESSIONAL_AVAILABILITY']),

		...mapActions('availability', ['DeleteAvailability']),

		...mapActions('message', ['GetConversationUnreadCount']),

		async fetchPracticeData() {
			const { id } = this.practiceFromStore;

			if (!this.practiceImage) {
				axios
					.get(store.getters.getDOCUMENTS + '/images/logo/' + id, this.requestHeader)
					.then(response => {
						this.practiceImage = 'data:image/png;base64,' + response.data.data;
					})
					.catch(() => {
						this.avatar = 'no-avatar';
					});
			}
			if (!this.practiceData) {
				const practiceGet = await axios.get(`${this.API_URL}/companies/${id}`, this.requestHeader);
				this.practiceData = practiceGet.data.data;
			}
		},
		cancelPracticeView() {
			bus.$emit('change-context', 'locum-dashboard-landing-zone');
		},
		formatLocumRate(day) {
			return day && day.rate ? `R${day.rate}` : 'Not specified';
		},
		requestHeader() {
			return { headers: { Authorization: this.authToken } };
		},
		async doPracticeAcceptLocumApplication() {
			const { id } = this.practiceFromStore;

			const body = {
				id,
				status_reason: '-',
			};

			let requests = [];
			requests.push(axios.put(this.API_URL + '/offers/company/confirm-offer/' + this.booking.id, body, this.requestHeader));

			axios
				.all(requests)
				.then(() => {
					bus.$emit('change-context', 'practice-dashboard-landing-zone');
				})
				.catch(err => {
					console.error('error on book offer', err);
				});
		},
		async doPracticeDeclineLocumApplication() {
			const { id } = this.practiceFromStore;

			const body = {
				id,
				status_reason: "We noticed that you don't meet the necessary requirements.",
			};

			let requests = [];
			requests.push(axios.put(this.API_URL + '/offers/company/reject-offer/' + this.booking.id, body, this.requestHeader));

			axios
				.all(requests)
				.then(() => {
					bus.$emit('change-context', 'practice-dashboard-landing-zone');
				})
				.catch(err => {
					console.error('error on book offer', err);
				});
		},
		sendBookingRequest() {
			bus.$emit('change-context', 'practice-to-locum-create-booking-request');
		},
		cancelBooking() {
			if (this.viewSource === 'viewUpcomingBooking') {
				this.doSubmitUpcomingBookingCancellation();
			}
			if (this.viewSource === 'viewBookingRequestSent') {
				this.doPracticeCancelBookingRequest();
			}
			if (this.viewSource === 'viewApplicationSent') {
				this.doLocumCancelApplication();
			}
		},
		async doSubmitUpcomingBookingCancellation() {
			const body = {
				status_reason: this.cancellationReason,
			};
			const response = await axios.put(`${store.getters.getAPI}/bookings/schedule/${this.booking.id}/${this.practice.id}/cancel`, body, this.requestHeader);
			this.UPDATE_COMPANY_BOOKINGS(response.data.data);
			setTimeout(() => {
				bus.$emit('UpdateCalendar');
			}, 1000);
			bus.$emit('change-context', 'locum-dashboard-landing-zone');
		},
		async doLocumAcceptPrivateRequest() {
			var datesSelected = [];
			var newBooking_dates = [];
			const sortedDates = Object.keys(this.selectedDates).sort();
			if (sortedDates) {
				sortedDates.forEach(day => {
					const date = this.booking.request_dates.filter(date => date.date === day).map(date => date);
					var selectDate = {
						date: date[0].date,
						start_time: date[0].start_time,
						end_time: date[0].end_time,
					};
					datesSelected.push(selectDate);
					newBooking_dates.push(date[0].date);
				});
			}

			if (datesSelected.length < 1) return;
			this.loading = true;

			const { name, id: userId } = store.getters.user;

			const body = {
				id: userId,
				status_reason: 'accepted by ' + name,
				booking_dates: newBooking_dates,
				booking_dates_times: datesSelected,
			};
			//update selected Dates
			await axios
				.put(store.getters.getAPI + '/offers/company/private/accept-offer/' + this.booking.id, body, this.requestHeader)
				.then(({ data }) => {
					store.commit('ADD_AVAILABILITY', data.data);
				})
				.then(() => {
					this.loading = false;
					store.commit('PUSH_NOTIFICATION', { component: 'locum-booking-confirmed', data: ['derpderp'] });
					bus.$emit('change-context', 'locum-dashboard-landing-zone');
					this.apiRequest = false;
				})
				.catch(error => {
					console.error('error private request sent null', error);
				});
			setTimeout(() => {
				bus.$emit('UpdateCalendar');
			}, 1000);
		},
		async doLocumRejectPrivateRequest() {
			const { name, id: userId } = store.getters.user;

			const body = {
				id: userId,
				status_reason: 'rejected by ' + name,
			};

			await axios
				.put(store.getters.getAPI + '/offers/company/private/reject-offer/' + this.booking.id, body, this.requestHeader)
				.then(({ data }) => {
					this.UPDATE_OFFERS(data.data);
				})
				.then(() => {
					store.commit('PUSH_NOTIFICATION', { component: 'locum-booking-rejected', data: [''] });
					bus.$emit('change-context', 'locum-dashboard-landing-zone');
				})
				.catch(error => {
					console.error('error private request sent null', error);
				})
				.finally(() => {
					setTimeout(() => {
						bus.$emit('UpdateCalendar');
					}, 1000);
				});
		},
		async doLocumConfirmBookingRequest() {
			const { id, date } = this.booking;
			const body = {
				id: this.practice.id,
				status: 'confirmed',
				message: 'Thank you for your booking request I will come through.',
			};

			axios
				.put(`${store.getters.getAPI}/calendar/professional/availability/accept-booking/${id}/${date}`, body, this.requestHeader)
				.then(({ data }) => {
					store.commit('ADD_AVAILABILITY', data.data);
					store.commit('PUSH_NOTIFICATION', { component: 'locum-booking-confirmed', data: ['derpderp'] });
					bus.$emit('change-context', 'locum-dashboard-landing-zone');
				})
				.catch(err => {
					console.error('error on bookign requests', err);
				});
			setTimeout(() => {
				bus.$emit('UpdateCalendar');
			}, 1000);
		},
		async doLocumRejectBookingRequest() {
			const { id, date } = this.booking;

			const body = {
				id: this.practice.id,
				status: 'rejected',
				message: 'Thank you for your booking request but I am no longer available for this slot',
			};

			await axios
				.put(`${store.getters.getAPI}/calendar/professional/availability/reject-booking/${id}/${date}`, body, this.requestHeader)
				.then(({ data }) => {
					store.dispatch('ADD_AVAILABILITY', data.data);
				})
				.then(async () => {
					store.commit('PUSH_NOTIFICATION', { component: 'locum-booking-rejected', data: [''] });
					await this.createPublicOffer();
					bus.$emit('change-context', 'locum-dashboard-landing-zone');
				})
				.catch(error => {
					console.error('error request sent null', error);
				})
				.finally(() => {
					setTimeout(() => {
						bus.$emit('UpdateCalendar');
					}, 1000);
				});
		},
		async createPublicOffer() {
			const { start_time, end_time, date, booking_dates, notes, lunch, rates, experience: searchExperience, languages, profession, skills, request_dates } = this.booking;
			const {
				id,
				name,
				contact,
				email,
				industry,
				address: { unit_no, building_name, country, postal_code, province, region, street, suburb },
			} = this.practice;

			const sortedDates = booking_dates.sort((a, b) => moment(a).diff(moment(b)));

			const payload = {
				start_time,
				end_time,
				date,
				end_date: booking_dates[booking_dates.length - 1],
				company: {
					id,
					name,
					contact,
					email,
					industry,
					address: {
						unit_no,
						building_name,
						country,
						postal_code,
						province,
						region,
						street,
						suburb,
					},
				},
				notes,
				profession,
				experience: searchExperience,
				languages,
				lunch,
				skills,
				available_dates: sortedDates,
				rates,
				request_dates: request_dates,
			};

			try {
				await this.UpsertOffer(payload);
			} catch (err) {
				console.error('Failed to create private offer', err);
			}
			bus.$emit('UpdateCalendar');
		},
		getYearsExperience() {
			return 'experience' in this.locum ? moment().diff(this.locum.experience.start_date, 'years') : 0;
		},
		async doLocumCancelApplication() {
			const body = {
				id: this.booking.requestId,
				status: 'cancelled',
				message: this.cancellationReason,
			};

			await axios
				.put(store.getters.getAPI + '/offers/company/cancel-offer-request/' + this.booking.id, body, this.requestHeader)
				.then(() => {
					bus.$emit('change-context', 'locum-dashboard-landing-zone');
				})
				.catch(error => {
					console.error('error request sent null', error);
				})
				.finally(() => {
					bus.$emit('UpdateCalendar');
				});
		},
		async doLocumConfirmOffer() {
			var datesSelected = [];
			const sortedDates = Object.keys(this.selectedDates).sort();
			if (sortedDates) {
				sortedDates.forEach(day => {
					const date = this.booking.request_dates.filter(date => date.date === day).map(date => date);
					var selectDate = {
						date: date[0].date,
						start_time: date[0].start_time,
						end_time: date[0].end_time,
					};
					datesSelected.push(selectDate);
				});
			}

			if (datesSelected.length < 1) return;
			this.loading = true;

			const {
				id: userId,
				email,
				first_name,
				last_name,
				contact,
				profession,
				qualifications: { institution, qualification, year_qualified },
				working_hours: { public_holidays, saturday, sundays, weekdays },
			} = store.getters.user;
			const dates = sortedDates; //Object.keys(this.selectedDates).filter(date => this.selectedDates[date]);

			const body = {
				id: userId,
				email,
				name: first_name,
				surname: last_name,
				contact,
				profession,
				qualifications: {
					institution,
					qualification,
					year_qualified,
				},
				rates: {
					public_holidays: 'R' + public_holidays.rate,
					saturday: 'R' + saturday.rate,
					sundays: 'R' + sundays.rate,
					weekdays: 'R' + weekdays.rate,
				},
				booking_dates: dates,
				booking_dates_times: datesSelected,
			};
			axios
				.put(store.getters.getAPI + '/offers/company/book-offer/' + this.booking.id, body, this.requestHeader)
				.then(response => {
					this.UPDATE_OFFERS(response.data.data);
					store.commit('PUSH_NOTIFICATION', { component: 'locum-application-sent', data: ['derpderp'] });
					bus.$emit('change-context', 'locum-dashboard-landing-zone');
				})
				.catch(err => {
					console.error('error on book offer', err);
				})
				.finally(() => {
					this.loading = false;
					setTimeout(() => {
						bus.$emit('UpdateCalendar');
					}, 500);
				});
		},

		async getDateAndTimeRangeAsString(dateRange) {
			var dateTimeString = '';
			if (dateRange && dateRange.length > 0) {
				//Format date array to words
				var startDate = dateRange[0].date;
				var startTime = '';
				var previousDayComplete = false;
				var endTime = '';
				for (let i = 0; i < dateRange.length; i++) {
					const date = dateRange[i];
					//format start time field
					startTime = date.start_time.substr(11, 5);
					endTime = date.end_time.substr(11, 5);
					if (i === 0) {
						if (dateRange.length === 1) {
							dateTimeString = date.date + ' From ' + startTime + ' To ' + endTime;
							break;
						} else {
							startDate = date.date;
							dateTimeString = startDate;
						}
					} else if (i > 0) {
						startDate = date.date;
						//if times differ of previous day
						if (dateRange[i - 1].start_time.substr(11, 5) !== startTime || dateRange[i - 1].end_time.substr(11, 5) !== endTime) {
							if (i === dateRange.length - 1) {
								if (!previousDayComplete)
									dateTimeString += ' From ' + dateRange[i - 1].start_time.substr(11, 5) + ' to ' + dateRange[i - 1].end_time.substr(11, 5) + '; ';
								dateTimeString += date.date + ' From ' + startTime + ' to ' + endTime;
							} else {
								if (!previousDayComplete) {
									dateTimeString += ' From ' + dateRange[i - 1].start_time.substr(11, 5) + ' to ' + dateRange[i - 1].end_time.substr(11, 5) + '; ' + date.date;
								}
							}
							previousDayComplete = false;
						}
						//else if not consecutive days - fix if statememt
						else if ((new Date(date.date).getTime() - new Date(dateRange[i - 1].date).getTime()) / (1000 * 3600 * 24) !== 1) {
							if (i === dateRange.length - 1) {
								if (!previousDayComplete)
									dateTimeString += ' From ' + dateRange[i - 1].start_time.substr(11, 5) + ' to ' + dateRange[i - 1].end_time.substr(11, 5) + '; ';
								dateTimeString += date.date + ' From ' + startTime + ' to ' + endTime;
							} else {
								if (!previousDayComplete) {
									dateTimeString += ' From ' + dateRange[i - 1].start_time.substr(11, 5) + ' to ' + dateRange[i - 1].end_time.substr(11, 5) + '; ' + date.date;
								}
							}
							previousDayComplete = false;
						}
						//else if consecutive days with consecutive times
						else if ((new Date(date.date).getTime() - new Date(dateRange[i - 1].date).getTime()) / (1000 * 3600 * 24) === 1) {
							if (i === dateRange.length - 1) {
								dateTimeString += ' - ' + date.date + ' From ' + startTime + ' to ' + endTime;
							} else if ((new Date(dateRange[i + 1].date).getTime() - new Date(date.date).getTime()) / (1000 * 3600 * 24) !== 1) {
								dateTimeString += ' - ' + date.date + ' From ' + startTime + ' to ' + endTime + '; ' + dateRange[i + 1].date;
								previousDayComplete = true;
							}
						}
					}
				}
			}
			return dateTimeString;
		},

		doPracticeCancelBookingRequest() {
			if (!this.isPrivate) {
				this.doPracticeCancelPublicBookingRequest();
			} else {
				this.doPracticeCancelPrivateBookingRequest();
			}
			store.commit('POP_CHANNEL_NOTIFICATION', { channel: 'BookingRequestsSent', identity: this.booking.booking_ref });
		},
		async doPracticeCancelPrivateBookingRequest() {
			const body = {
				status_reason: this.cancellationReason,
			};

			await axios
				.put(this.API_URL + '/offers/company/private/cancel-offer/' + this.booking.id, body, this.requestHeader)
				.then(response => {
					this.UPDATE_OFFERS(response.data.data);
				})
				.then(() => {
					bus.$emit('change-context', 'practice-dashboard-landing-zone');
				})
				.catch(error => {
					console.error('ERROR cancelling private booking request', error);
				})
				.finally(() => {
					bus.$emit('UpdateCalendar');
				});
		},
		async doPracticeCancelPublicBookingRequest() {
			const body = {
				id: this.booking.id,
				status_reason: this.cancellationReason,
			};

			await axios
				.put(this.API_URL + '/calendar/professional/availability/cancel-booking-request/' + this.booking.id + '/' + this.booking.date, body, this.requestHeader)
				.then(async response => {
					store.dispatch('UPDATE_AVAILABILITY', response.data.data);
				})
				.then(() => {
					bus.$emit('change-context', 'practice-dashboard-landing-zone');
				})
				.catch(error => {
					console.error('ERROR cancelling public booking', error);
				})
				.finally(() => {
					bus.$emit('UpdateCalendar');
				});
		},
		async deletePublicOffer() {
			const offer = this.booking;

			await axios
				.put(
					this.API_URL + '/offers/company/cancel-offer/' + offer.id,
					{
						status_reason: '-practice cancelled offer-',
					},
					this.requestHeader
				)
				.then(() => {
					bus.$emit('UpdateCalendar');
					store.commit('DELETE_OFFER', offer);
					store.commit('PUSH_NOTIFICATION', { component: 'practice-offer-deleted', data: [''] });
					store.commit('POP_CHANNEL_NOTIFICATION', { channel: 'OffersPosted', identity: offer.id });

					bus.$emit('change-context', 'practice-dashboard-landing-zone');
				})
				.catch(error => {
					console.error('Error deleting public offer ', error);
				});
		},
		async startDelete() {
			const { booking_dates } = this.booking;
			let date = moment(booking_dates[0]).format('YYYY-MM-DD').toString();
			const booking = { ...this.booking, date };

			try {
				await this.DeleteAvailability(booking);

				this.selectedOpen = false;

				this.REMOVE_PROFESSIONAL_AVAILABILITY(this.booking);

				store.commit('PUSH_NOTIFICATION', { component: 'locum-availability-deleted', data: [''] });
				bus.$emit('change-context', 'locum-dashboard-landing-zone');
			} catch (err) {
				console.error('Error deleting availability ', err);
			}

			bus.$emit('UpdateCalendarEvents');
		},
		editAvailability() {
			this.$refs.locumEditBooking.open(this.booking, this.bookingType === 'Availability' ? 'Available' : 'Unavailable');
		},
		async editApplicationToOffer() {
			this.$refs.locumEditApplication.open();
		},

		updateApplicationDetails(updatedApplication) {
			this.selectedDatesSorted = updatedApplication.booking_dates_times;
			this.booking.request_dates = updatedApplication.booking_dates_times;
			this.booking.booking_dates_times = updatedApplication.booking_dates_times;
			setTimeout(() => {
				bus.$emit('UpdateCalendar');
			}, 500);
		},

		async openMessageDialog() {
			let receiverDetails = {
				id: this.practice.id,
				name: this.practice.name,
			};
			bus.$emit('show-message-dialog', receiverDetails, this.locum.id);
			this.unreadMessageCount = 0;
		},

		async getUnreadMessageCount() {
			const unreadCount = await this.GetConversationUnreadCount({
				receivedByID: this.locum.id,
				sentByID: this.practiceFromStore.id,
			});
			this.unreadMessageCount = unreadCount;
		},
	},
};
</script>
<style scoped>
.badge-styling {
	position: absolute;
	right: 0.5rem;
	top: -1rem;
}
</style>
